import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

export type ConsultaReembolsoContext = {
    hasReembolsos: boolean;
    setHasReembolsos: Dispatch<SetStateAction<boolean>>;
};

interface ConsultaReembolsoProvider {
    children: ReactNode;
}

const ConsultaReembolsoContext = createContext<ConsultaReembolsoContext>({} as ConsultaReembolsoContext);

export function ConsultaReembolsoProvider({ children }: ConsultaReembolsoProvider) {
    const [hasReembolsos, setHasReembolsos] = useState(false);

    return (
        <ConsultaReembolsoContext.Provider
            value={{
                hasReembolsos,
                setHasReembolsos,
            }}
        >
            {children}
        </ConsultaReembolsoContext.Provider>
    );
}

export const useConsultaReembolsoContext = (): ConsultaReembolsoContext => useContext(ConsultaReembolsoContext);
